/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stripe_DashboardInputs */

const en_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Dashboard`)
};

const es_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de Stripe`)
};

const fr_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord Stripe`)
};

const de_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe-Dashboard`)
};

const ja_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe ダッシュボード`)
};

const zh_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 仪表板`)
};

const ar_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة تحكم Stripe`)
};

const id_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasbor Stripe`)
};

const it_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard di Stripe`)
};

const ru_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель управления Stripe`)
};

const pt_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel do Stripe`)
};

const ko_stripe_dashboard = /** @type {(inputs: Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 대시보드`)
};

/**
* | output |
* | --- |
* | "Stripe Dashboard" |
*
* @param {Stripe_DashboardInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const stripe_dashboard = /** @type {((inputs?: Stripe_DashboardInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stripe_DashboardInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stripe_dashboard(inputs)
	if (locale === "es") return es_stripe_dashboard(inputs)
	if (locale === "fr") return fr_stripe_dashboard(inputs)
	if (locale === "de") return de_stripe_dashboard(inputs)
	if (locale === "ja") return ja_stripe_dashboard(inputs)
	if (locale === "zh") return zh_stripe_dashboard(inputs)
	if (locale === "ar") return ar_stripe_dashboard(inputs)
	if (locale === "id") return id_stripe_dashboard(inputs)
	if (locale === "it") return it_stripe_dashboard(inputs)
	if (locale === "ru") return ru_stripe_dashboard(inputs)
	if (locale === "pt") return pt_stripe_dashboard(inputs)
	return ko_stripe_dashboard(inputs)
});